/* ── Magnimoo FAQ interactions ─────────────────────── */
(function () {
  'use strict';

  var root = document.querySelector('[data-mg-faq]');
  if (!root) return;

  var searchWrap = root.querySelector('[data-mg-faq-search]');
  var searchInput = root.querySelector('.mg-faq-search-input');
  var searchClear = root.querySelector('.mg-faq-search-clear');
  var searchStatus = root.querySelector('[data-mg-faq-status]');
  var emptyState = root.querySelector('[data-mg-faq-empty]');
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-mg-faq-item]'));
  var categories = Array.prototype.slice.call(root.querySelectorAll('[data-mg-faq-category]'));
  var pills = Array.prototype.slice.call(root.querySelectorAll('[data-mg-faq-pill]'));
  var expandButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mg-faq-expand]'));
  var spotlightLinks = Array.prototype.slice.call(root.querySelectorAll('[data-mg-faq-spotlight]'));

  // Shopper-facing strings come from locale keys via data attributes on the root (sections/page-faq.liquid).
  function msg(name) { return root.getAttribute('data-mg-faq-msg-' + name) || ''; }
  function fill(template, values) {
    return template.replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
    });
  }

  // ── Live search ──────────────────────────────
  function matchItem(item, query) {
    if (!query) return true;
    var q = query.toLowerCase();
    var question = (item.getAttribute('data-question') || '').toLowerCase();
    if (question.indexOf(q) !== -1) return true;
    var answer = item.querySelector('.mg-faq-answer');
    if (answer && answer.textContent.toLowerCase().indexOf(q) !== -1) return true;
    return false;
  }

  function applySearch(query) {
    var visibleCount = 0;
    var q = (query || '').trim();

    items.forEach(function (item) {
      if (matchItem(item, q)) {
        item.removeAttribute('hidden');
        visibleCount++;
      } else {
        item.setAttribute('hidden', '');
        item.removeAttribute('open');
      }
    });

    // Hide whole category sections that have no visible items
    categories.forEach(function (cat) {
      var anyVisible = Array.prototype.some.call(
        cat.querySelectorAll('[data-mg-faq-item]'),
        function (it) { return !it.hasAttribute('hidden'); }
      );
      cat.style.display = anyVisible ? '' : 'none';
    });

    if (searchWrap) {
      searchWrap.classList.toggle('is-dirty', q.length > 0);
    }

    if (emptyState) {
      emptyState.setAttribute('data-visible', visibleCount === 0 && q.length > 0 ? 'true' : 'false');
    }

    if (searchStatus) {
      if (q.length === 0) {
        searchStatus.textContent = '';
      } else if (visibleCount === 0) {
        searchStatus.textContent = fill(msg('no-matches'), { query: q });
      } else {
        searchStatus.textContent = fill(msg('showing'), { visible: visibleCount, total: items.length });
      }
    }
  }

  var searchTimer = null;
  if (searchInput) {
    searchInput.addEventListener('input', function (e) {
      if (searchTimer) clearTimeout(searchTimer);
      var value = e.target.value;
      searchTimer = setTimeout(function () { applySearch(value); }, 150);
    });

    // Escape clears
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        searchInput.value = '';
        applySearch('');
      }
    });
  }

  if (searchClear) {
    searchClear.addEventListener('click', function () {
      if (!searchInput) return;
      searchInput.value = '';
      searchInput.focus();
      applySearch('');
    });
  }

  // ── Expand-all toggle per category ──────────
  expandButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cat = btn.getAttribute('data-cat');
      if (!cat) return;
      var catItems = root.querySelectorAll('[data-mg-faq-category][data-cat="' + cat + '"] [data-mg-faq-item]');
      var isExpanding = btn.getAttribute('aria-expanded') !== 'true';
      Array.prototype.forEach.call(catItems, function (item) {
        if (item.hasAttribute('hidden')) return;
        if (isExpanding) {
          item.setAttribute('open', '');
        } else {
          item.removeAttribute('open');
        }
      });
      btn.setAttribute('aria-expanded', isExpanding ? 'true' : 'false');
      var label = btn.querySelector('[data-mg-faq-expand-label]');
      if (label) {
        label.textContent = isExpanding ? '\u2923 ' + msg('collapse') : '\u2922 ' + msg('expand');
      }
    });
  });

  // ── Sticky nav active-pill tracking ──────────
  if ('IntersectionObserver' in window && categories.length > 0) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var cat = entry.target.getAttribute('data-cat');
          pills.forEach(function (pill) {
            if (pill.getAttribute('data-cat') === cat) {
              pill.setAttribute('aria-current', 'location');
            } else {
              pill.removeAttribute('aria-current');
            }
          });
        });
      },
      {
        rootMargin: '-40% 0px -50% 0px',
        threshold: 0
      }
    );
    categories.forEach(function (cat) { observer.observe(cat); });
  }

  // Smooth-scroll + open target from pill or spotlight
  function scrollAndOpen(targetId) {
    if (!targetId) return;
    var el = document.getElementById(targetId);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // If the target is a <details>, open it
    if (el.tagName && el.tagName.toLowerCase() === 'details') {
      setTimeout(function () { el.setAttribute('open', ''); }, 120);
    }
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function (e) {
      var href = pill.getAttribute('href') || '';
      if (href.indexOf('#') === 0) {
        e.preventDefault();
        scrollAndOpen(href.slice(1));
      }
    });
  });

  spotlightLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = link.getAttribute('data-target');
      if (target) {
        e.preventDefault();
        scrollAndOpen(target);
      }
    });
  });

})();
